module.exports = __webpack_public_path__ + "img/tre-penne-logo-icon.b62c60b9.png";